export default __webpack_public_path__ + "static/media/icon_person_male.faef9604.png";